import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["entity", "eager", "src", "width", "height", "circle", "fit", "fullscreen", "actualWidthFactor", "ratio", "sizesHint"];
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../styleVars';
import { ImageEntity } from './entitySpec';
import { generateSources } from './ImageUtils';
var Wrapper = styled.div.withConfig({
  componentId: "sc-wadapo-0"
})(["height:100%;display:flex;justify-content:inherit;align-items:inherit;align-content:inherit;flex-direction:inherit;"]);
var Container = styled.div.withConfig({
  componentId: "sc-wadapo-1"
})(["height:", ";width:100%;"], function (props) {
  var _props$height;

  return (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'inherit';
});
var Picture = styled.picture.withConfig({
  componentId: "sc-wadapo-2"
})(["display:flex;height:inherit;width:inherit;", ""], function (props) {
  return props.fullscreen ? 'position: absolute;' + 'top: 0;' + 'right: 0;' + 'left: 0;' + 'bottom: 0;' : '';
});
var Img = styled.img.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['entity', 'radius', 'fit', 'fullscreen', 'dimX', 'dimY', 'className', 'isLoading'].includes(prop);
  }
}).withConfig({
  componentId: "sc-wadapo-3"
})(["display:flex;width:", ";height:", ";object-fit:", ";border-radius:", ";object-position:", ";animation:", ";@keyframes skeleton-loading{0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}}"], function (props) {
  var _props$dimX;

  return (_props$dimX = props.dimX) !== null && _props$dimX !== void 0 ? _props$dimX : '100%';
}, function (props) {
  var _props$dimY;

  return (_props$dimY = props.dimY) !== null && _props$dimY !== void 0 ? _props$dimY : 'auto';
}, function (props) {
  return props.fit ? 'contain' : 'cover';
}, function (props) {
  return props.radius;
}, function (props) {
  return props.entity === ImageEntity.Player && !props.fullscreen ? 'top' : props.entity === ImageEntity.Branding ? 'right' : 'center';
}, function (props) {
  return props.fit || !props.isLoading ? 'none' : 'skeleton-loading 1.5s ease-in-out 0.5s infinite';
}, COLORS.lightGrey, COLORS.lighterGrey, COLORS.lightGrey);
var Placeholder = styled.div.withConfig({
  componentId: "sc-wadapo-4"
})(["width:", ";height:", ";object-fit:", ";border-radius:", ";background-color:", ";"], function (props) {
  var _props$dimX2;

  return (_props$dimX2 = props.dimX) !== null && _props$dimX2 !== void 0 ? _props$dimX2 : '100%';
}, function (props) {
  var _props$dimY2;

  return (_props$dimY2 = props.dimY) !== null && _props$dimY2 !== void 0 ? _props$dimY2 : 'auto';
}, function (props) {
  return props.fit ? 'contain' : 'cover';
}, function (props) {
  return props.radius;
}, COLORS.lightestGrey);

var Image = function Image(_ref) {
  var entity = _ref.entity,
      _ref$eager = _ref.eager,
      eager = _ref$eager === void 0 ? false : _ref$eager,
      src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$circle = _ref.circle,
      circle = _ref$circle === void 0 ? false : _ref$circle,
      _ref$fit = _ref.fit,
      fit = _ref$fit === void 0 ? false : _ref$fit,
      _ref$fullscreen = _ref.fullscreen,
      fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen,
      actualWidthFactor = _ref.actualWidthFactor,
      ratio = _ref.ratio,
      sizesHint = _ref.sizesHint,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var ref = useRef(null);
  var parsedHeight = typeof height === 'number' ? "".concat(height, "px") : height;
  var parsedWidth = typeof width === 'number' ? "".concat(width, "px") : width;

  if (src && src.path) {
    var _generateSources = generateSources(src, entity, ratio, actualWidthFactor, parsedWidth, sizesHint),
        sources = _generateSources.sources,
        fallbackSrc = _generateSources.fallbackSrc,
        imageSizeAttributes = _generateSources.imageSizeAttributes;

    var fallback = /*#__PURE__*/React.createElement(Img, {
      className: props.className,
      loading: eager ? 'eager' : 'lazy',
      entity: entity,
      src: fallbackSrc,
      alt: (props === null || props === void 0 ? void 0 : props.alt) || src.description || '',
      title: (props === null || props === void 0 ? void 0 : props.title) || src.description || '',
      dimX: parsedWidth,
      dimY: parsedHeight,
      width: imageSizeAttributes.width,
      height: imageSizeAttributes.height,
      fit: fit,
      radius: circle ? '50%' : '0',
      fullscreen: fullscreen,
      fetchpriority: props.fetchPriority,
      isLoading: isLoading,
      onLoad: function onLoad() {
        return setIsLoading(false);
      }
    }); // Generate <picture>-Tag or if not delivered by CDN generate <img>-Tag

    var picture = !src.svg ? /*#__PURE__*/React.createElement(Picture, {
      fullscreen: fullscreen
    }, sources, fallback) : fallback;
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
      height: parsedHeight,
      ref: ref
    }, picture));
  } else {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Placeholder, {
      dimX: parsedWidth,
      dimY: parsedHeight,
      fit: fit,
      radius: circle ? '50%' : 'none',
      ref: ref
    }));
  }
};

export { Image };
//# sourceMappingURL=Image.js.map